import React from "react";
import { Box } from "@mui/material";
import { CollabRequests } from "../../pages/admin/adminHomePage/CollabRequests";

export const CollabRequestsTable = ({ minified = false }) => {
  if (minified) {
    return (
      <Box>
        <CollabRequests hideFooter={true} viewOnly={true} />
      </Box>
    );
  }

  return (
    <Box>
      <CollabRequests />
    </Box>
  );
};
